import { apiRequest, apiFormRequest } from "../configs/axios.config";

interface IPostRequest {
  url: string;
  data?: any;
}

const handleGlobalPostRequest = ({ url, data }: IPostRequest) => {
  return apiRequest.post(url, data).then((response) => response.data);
};
const handleGlobalFormPostRequest = ({ url, data }: IPostRequest) => {
  return apiFormRequest.post(url, data).then((response) => response.data);
};
const handleGlobalPatchRequest = ({ url, data }: IPostRequest) => {
  return apiRequest.patch(url, data).then((response) => response.data);
};

const handleGlobalPutRequest = ({ url, data }: IPostRequest) => {
  return apiRequest.put(url, data).then((response) => response.data);
};

const handleGlobalDeleteRequest = ({ url }: { url: string }) => {
  return apiRequest.delete(url).then((response) => response.data);
};

export {
  handleGlobalFormPostRequest,
  handleGlobalDeleteRequest,
  handleGlobalPatchRequest,
  handleGlobalPostRequest,
  handleGlobalPutRequest,
};
